import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ImageGallery from './ImageGallery';

const BeforeAfterGallery: React.FC = () => {
  const { translations, language } = useLanguage();
  
  // Before and After Gallery images
  const galleryImages = [
    '/images/SeaDent  Before and After 1.jpg',
    '/images/SeaDent  Before and After 2.jpg',
    '/images/SeaDent  Before and After 3.jpg',
    '/images/SeaDent  Before and After 4.jpg',
    '/images/SeaDent  Before and After 5.jpg',
    '/images/SeaDent  Before and After 6.jpg',
    '/images/SeaDent  Before and After 7.jpg',
    '/images/SeaDent  Before and After 8.jpg',
    '/images/SeaDent  Before and After 9.jpg',
    '/images/SeaDent  Before and After 10.jpg',
    '/images/SeaDent  Before and After 11.jpg'
  ];

  // Accessibility alt text in different languages
  const altTexts = {
    de: "SeaDent Mallorca Vorher-Nachher Bilder",
    en: "SeaDent Mallorca Before-After Images",
    es: "SeaDent Mallorca Imágenes de antes y después",
    ru: "SeaDent Майорка - изображения до и после"
  };
  
  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white" id="before-after">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-navy mb-4">
            {language === 'de' ? 'Vorher-Nachher' : 
             language === 'en' ? 'Before and After' : 
             language === 'ru' ? 'До и после' :
             'Antes y después'}
          </h2>
          <p className="max-w-3xl mx-auto text-gray-800 mb-6">
            {language === 'de' ? 'Sehen Sie die Ergebnisse unseres fortschrittlichen Composite Smile Makeovers: minimalinvasiv, in einer Sitzung, zahnschmelzerhaltend.' : 
             language === 'en' ? 'See the results of our advanced Composite Smile Makeover: minimally invasive, one-session, enamel-preserving.' : 
             language === 'ru' ? 'Посмотрите результаты нашего продвинутого Композитного Преображения Улыбки: минимально инвазивно, за один сеанс, с сохранением эмали.' :
             'Vea los resultados de nuestro avanzado Composite Smile Makeover: mínimamente invasivo, en una sesión, preservando el esmalte.'}
          </p>
        </div>
        
        <div className="mx-auto max-w-5xl">
          <ImageGallery 
            images={galleryImages} 
            interval={6000}
            className="shadow-2xl rounded-lg overflow-hidden"
            altText={altTexts[language]}
            objectFit="contain"
          />
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterGallery; 